/**
 * Calls cb on parents of current, and current itself.
 */
export function doOnParents(
	current: Element,
	selector: string,
	cb: ( parent: Element ) => unknown
): void {
	cb( current );
	const parent = current.parentElement
		? current.parentElement.closest( selector )
		: null;
	if ( ! parent ) {
		return;
	}
	return doOnParents( parent, selector, cb );
}

// Includes the element itself
export function getAncestors( elem: Element ): Element[] {
	const ancestors: Element[] = [ elem ];
	let current: Element | null = elem;
	while ( current ) {
		ancestors.push( current );
		current = current.parentElement;
	}
	return ancestors;
}

export function isAncestor(
	ancestor: Element | null,
	element: Element | null
) {
	if ( ! ancestor || ! element ) {
		return false;
	}
	return getAncestors( element ).includes( ancestor );
}
